import React from "react";
import CompanyLevel from "./CompanyLevel";
import LocationLevel from "./LocationLevel";

function ApprovalLevels() {
  return (
    <div>
      <CompanyLevel />
      <LocationLevel />
    </div>
  );
}

export default ApprovalLevels;
